import { Col } from "react-bootstrap";
import navIcon2 from "../assets/img/nav-icon2.svg";
import demoIcon from "../assets/img/demo.svg";

export const ProjectCard = ({ title, description, imgUrl, demo, github }) => {
  return (
    <Col size={12} sm={6} md={4}>
      <div className="proj-imgbx">
        <img src={imgUrl} />
        <div className="proj-txtx">
          <h4>{title}</h4>
          <span>{description}</span>
          <div className="social-icon project-icon">
            <a href={github}>
            <img src={navIcon2} alt="" />
              
            </a>
            <a href={demo}>
            <img src={demoIcon} alt="" />
            </a>
          </div>
        </div>
      </div>
    </Col>
  )
}